import axios from "axios";
import React, { useEffect, useState } from "react";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../Configuration/API_URL";
import ClientOverview from "../../Components/ClientDashboard/Overview/ClientOverview";
import IncPortfolio from "../../Components/ClientDashboard/Overview/IncPortfolio";
import NetWorth from "../../Components/ClientDashboard/Overview/NetWorth";
import OverallPortfolioAnalysis from "../../Components/ClientDashboard/Overview/OverallPortfolioAnalysis";
import PortfolioValue from "../../Components/ClientDashboard/Overview/PortfolioValue";
import { Link } from "react-router-dom";
import pdfImg from "../../asset/images/pdf.svg";
import Advisory from "../../Components/ClientDashboard/Overview/Advisory";
import IncPortfolioNew from "../../Components/ClientDashboard/Overview/IncPortfolioNew";

function Overview() {
  const storeToken = localStorage.getItem("ssoToken");

  const [portAnalysis, setPortAnalysis] = useState();
  const getPortAnalysisDetails = async (clientCode) => {
    try {
      const getAnalysis = await axios.post(
        DASHBOARD_CLIENT_OVERVIEW.PortfolioAnalysis_URL,
        {
          clientCode: clientCode,
          // clientCode:"pun38"
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = getAnalysis.data.data;
      setPortAnalysis(res);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    let clientCode = "";
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getPortAnalysisDetails(clientCode);
    }
  }, []);
  return (
    <>
      {/* <!-- progress circles --> */}
      <ClientOverview
        Analysis={portAnalysis === undefined || null ? "-" : portAnalysis}
      />

      {/* <!-- portfolio-box --> */}

      <PortfolioValue
        portFolioData={portAnalysis === undefined || null ? "-" : portAnalysis}
      />

      {/* <!-- portfolio-box end --> */}

      {/* <!-- Overall Portfolio Analysis  --> */}

      {/* <OverallPortfolioAnalysis /> */}

      {/* <!-- Overall Portfolio Analysis End  --> */}

      {/* <!-- My Net Worth --> */}

      <NetWorth />

      {/* <!-- My Net Worth End --> */}

      {/* <!-- Inc in Portfolio over years --> */}

      {/* <IncPortfolio /> */}
      <IncPortfolioNew />

      {/* <!-- Inc in Portfolio over years End--> */}

      {/* <!-- Advisory --> */}

      {/* <Advisory /> */}

      {/* <!-- Advisory End--> */}
    </>
  );
}

export default Overview;
